/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit MaskedInputLabel.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import MaskedInput from 'DesignSystem/MaskedInput/logic.js'
import React from 'react'
import { css } from "emotion"
MaskedInput.displayName = 'MaskedInputLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  marginTop: 'var(--marginTop)',
marginRight: 'var(--marginRight)',
marginLeft: 'var(--marginLeft)',
marginBottom: 'var(--marginBottom)'})
styles.Text = css({label: 'Text',
  color: "#606060",
fontFamily: "WonderUnitSans",
fontSize: 8,
fontWeight: 500,
letterSpacing: 1,
textTransform: "uppercase",
position: "absolute",
  
transition: 'opacity 150ms linear, top 150ms ease-out',
willChange: 'opacity, top',
  top: 'var(--top)',
left: 'var(--left)',
opacity: 'var(--opacity)'})

export default function MaskedInputLabel({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  marginTop= 0,
marginRight= 0,
marginLeft= 0,
marginBottom= 0,
label= "label",
paddingLeft= 16,
isFocusedManual,
borderBottomLeftRadius= 8,
borderBottomRightRadius= 8,
borderTopLeftRadius= 8,
borderTopRightRadius= 8,
fontSize= 16,
fontWeight= 300,
value,
paddingBottom= 16,
paddingRight= 16,
paddingTop= 16,
placeholder,
onChange,
onSubmit,
autoFocus,
onBlur,
onFocus,
onKeyUp,
mask,
isInvalid
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="MaskedInputLabel.Vertical"
 data-view-path={dataViewPath}
 style={{'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="MaskedInputLabel.Text"
 data-view-path={dataViewPath}
 style={{'--left': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--opacity': isFocusedManual ? 1 : 0,'--top': isFocusedManual ? "-16px" : "0px"}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
<MaskedInput
 data-testid="MaskedInputLabel.MaskedInput"
 data-view-path={dataViewPath}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 fontSize={fontSize}
 fontWeight={fontWeight}
 value={value}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 placeholder={placeholder}
 onChange={onChange}
 onSubmit={onSubmit}
 autoFocus={autoFocus}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 mask={mask}
 isInvalid={isInvalid}
/>
</div>
{children}
</React.Fragment>)
}